import React, { useEffect, useState } from "react";
import {
  coupleNames,
  type WeddingLanguage,
  weddingContent,
} from "./content";
import heroImage from "../../assets/img/wedding-hero.jpg";

interface HeroProps {
  language: WeddingLanguage;
}

const weddingDate = new Date(2027, 0, 17, 18, 0, 0);

const getCountdown = () => {
  const remaining = Math.max(0, weddingDate.getTime() - Date.now());
  const totalSeconds = Math.floor(remaining / 1000);
  const days = Math.floor(totalSeconds / 86400);
  const hours = Math.floor((totalSeconds % 86400) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return { days, hours, minutes, seconds };
};

export function Hero({ language }: HeroProps) {
  const content = weddingContent[language].hero;
  const [countdown, setCountdown] = useState(getCountdown);
  const countdownLabels =
    language === "vi"
      ? ["Ngày", "Giờ", "Phút", "Giây"]
      : ["Days", "Hours", "Minutes", "Seconds"];

  useEffect(() => {
    const timer = window.setInterval(() => {
      setCountdown(getCountdown());
    }, 1000);

    return () => window.clearInterval(timer);
  }, []);

  const scrollToWishes = () => {
    const wishesSection = document.getElementById("wishes");
    if (wishesSection) {
      wishesSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  const scrollToGuestPhotos = () => {
    const guestPhotosSection = document.getElementById("guest-photos");
    if (guestPhotosSection) {
      guestPhotosSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="wedding-hero">
      <div
        className="wedding-hero__background wedding-hero__background--animated"
        style={{
          backgroundImage: `url(${heroImage})`,
        }}
      >
        <div className="wedding-hero__overlay" />
      </div>

      <div className="wedding-hero__content">
        <p className="wedding-hero__eyebrow wedding-hero__eyebrow--top">
          {content.eyebrowTop}
        </p>
        <h1 className="wedding-hero__names">{coupleNames}</h1>
        <div className="wedding-divider wedding-hero__divider" />
        <p className="wedding-hero__eyebrow wedding-hero__eyebrow--bottom">
          {content.eyebrowBottom}
        </p>

        <div className="wedding-hero__details">
          <div className="wedding-countdown" aria-label="Countdown to wedding day">
            {Object.values(countdown).map((value, index) => (
              <div className="wedding-countdown__item" key={countdownLabels[index]}>
                <span className="wedding-countdown__value">
                  {String(value).padStart(2, "0")}
                </span>
                <span className="wedding-countdown__label">
                  {countdownLabels[index]}
                </span>
              </div>
            ))}
          </div>
          <p className="wedding-hero__date">{content.date}</p>
          <a
            className="wedding-hero__location"
            href={weddingContent[language].details.directionsUrl}
            target="_blank"
            rel="noreferrer"
          >
            {content.location}
          </a>
        </div>

        <div className="wedding-hero__actions">
          <button onClick={scrollToWishes} className="wedding-button">
            {content.cta}
          </button>
          <button
            onClick={scrollToGuestPhotos}
            className="wedding-button wedding-button--secondary"
          >
            {content.guestPhotosCta}
          </button>
        </div>
      </div>
    </div>
  );
}
